import {
    DefaultScheduler,
    RateLimitedWorkerDecoratorFactory
} from "@tenera/upload_workers";

import AttachmentUploadWorkerFactory from "../scheduler/AttachmentUploadWorkerFactory";
import DataStoreAttachmentRecordDAOFactory from "../../record/datastore/DataStoreAttachmentRecordDAOFactory";
import { DefaultAttachmentUploadManager } from "./DefaultAttachmentUploadManager";
import FixedDelayTokenRefillStrategyFactory from "../../../util/ratelimit/FixedDelayTokenRefillStrategyFactory";
import LocalForageAttachmentContentDAOFactory from "../../content/localforage/LocalForageAttachmentContentDAOFactory";
import { LocalForageAttachmentRecordDAOFactory } from "../../record/localforage/LocalForageAttachmentRecordDAOFactory";
import { LocalForageAttachmentUploadStatusDAOFactory } from "../status/LocalForageAttachmentUploadStatusDAOFactory";
import TokenBucketBasedRateLimiterFactory from "@tenera/upload_workers/dist/src/ratelimit/TokenBucketBasedRateLimiterFactory";
import { attachmentUploadQueue } from "./AttachmentUploadQueueFactory";

export default class DefaultAttachmentUploadManagerFactory {
    private static readonly TOKEN_BUCKET_CAPACITY = 10;
    private static readonly MIN_DELAY_IN_MILLISECOND = 1000;

    private static readonly RATE_LIMITER = TokenBucketBasedRateLimiterFactory.create(
        this.TOKEN_BUCKET_CAPACITY,
        FixedDelayTokenRefillStrategyFactory.create(this.MIN_DELAY_IN_MILLISECOND)
    );

    private static readonly INSTANCE = new DefaultAttachmentUploadManager(
        LocalForageAttachmentUploadStatusDAOFactory.getInstance(),
        DataStoreAttachmentRecordDAOFactory.getInstance(),
        LocalForageAttachmentRecordDAOFactory.getInstance(),
        LocalForageAttachmentContentDAOFactory.getInstance(),
        attachmentUploadQueue,
        new DefaultScheduler(
            new RateLimitedWorkerDecoratorFactory(
                this.RATE_LIMITER,
                new AttachmentUploadWorkerFactory()
            ),
            attachmentUploadQueue,
        )
    );

    public static getInstance() {
        return this.INSTANCE;
    }
}